<template>
  <div>
    <div v-if="isStep(0)" class="py-4 text-center">
      <i class="fa fa-spin fa-spinner fa-2x"></i>
    </div>
    <div v-if="isStep(0.001)">
      <h5 class="mb-4 text-center">
        <b>Selecciona el tipo de venta</b>
      </h5>
      <div v-if="!loading" class="row mb-3">
        <div class="col-6">
          <button type="button" class="btn btn-action btn-block" @click="okTypeShop()">
            Call center
          </button>
        </div>
        <div class="col-6">
          <button type="button" class="btn btn-primary btn-block" @click="okTypeShop(true)">
            Venta en sede
          </button>
        </div>
      </div>
      <div v-else class="py-4 text-center">
        <i class="fa fa-spin fa-spinner fa-2x"></i>
      </div>
    </div>
    <div v-if="isStep(0.01)">
      <h5 class="mb-3">
        <b>Selecciona el distrito del paciente</b>
      </h5>
      <div class="mb-4">
        <div>
          <multiselect
            v-model="product"
            deselect-label=""
            track-by="name"
            label="name"
            selectLabel="Presione enter para seleccionar"
            placeholder="Seleccionar"
            :custom-label="labelDistrict"
            :options="products"
            :searchable="true"
            :allow-empty="false"
          >
            <template slot="singleLabel" slot-scope="{ option }">
              <strong>{{ option.name }}</strong>
              <br />
              <b class="mr-1">Delivery: </b>
              <span>S/ </span>
              <span>{{ option.price.toFixed(2) }}</span>
            </template>
          </multiselect>
        </div>
      </div>
      <div class="text-right">
        <button type="button" class="btn btn-action px-5" :disabled="!product" @click="step = 0.02">
          Continuar
        </button>
      </div>
    </div>
    <form v-if="isStep(0.02)" @submit.prevent="getAllTickets()">
      <h5 class="mb-3">
        <a href="#" class="mr-2 text-dark" @click.prevent="step = 0.01">
          <i class="fa fa-arrow-left"></i>
        </a>
        <b>Ingrese la dirección del comprador</b>
      </h5>
      <div class="mb-4">
        <div class="form-group">
          <label for="pAddress" class="mb-1">Dirección completa</label>
          <div>
            <input
              v-model="pAddress.address"
              id="pAddress"
              class="form-control form-control-sm text-uppercase"
              type="text"
              placeholder="Ejm: Av. Larco 220 - Piso 2, Miraflores - Lima"
              required
              @input="forceUpper($event, pAddress, 'address')"
            />
          </div>
        </div>
        <div class="form-group">
          <label for="pReference" class="mb-1">Referencia</label>
          <div>
            <input
              v-model="pAddress.reference"
              id="pReference"
              class="form-control form-control-sm text-uppercase"
              type="text"
              placeholder="Ejm: 1 Cuadra del Parque Kennedy"
              required
              @input="forceUpper($event, pAddress, 'reference')"
            />
          </div>
        </div>
      </div>
      <div class="text-right">
        <button type="submit" class="btn btn-action px-5" :disabled="loading">Continuar</button>
      </div>
    </form>
    <div v-if="isStep(0.1)">
      <h5 class="mb-3">
        <a href="#" class="mr-2 text-dark" @click.prevent="step = 0.3">
          <i class="fa fa-arrow-left"></i>
        </a>
        <b>Selecciona el día para la cita</b>
      </h5>
      <div class="mb-3">
        <v-date-picker
          v-model="selectedDate"
          :available-dates="availableDates"
          :attributes="attributes"
          :from-date="selectedDate || availableDates[0].start"
          :masks="{ weekdays: 'WWW' }"
          is-inline
          is-expanded
          @input="selectDate($event)"
        />
      </div>
      <div class="text-right">
        <button
          type="button"
          class="btn btn-action px-5"
          :disabled="!selectedDate"
          @click="nextSelectDate()"
        >
          Continuar
        </button>
      </div>
    </div>
    <div v-if="isStep(0.2)">
      <h5 class="mb-3">
        <a href="#" class="mr-2 text-dark" @click.prevent="step = 0.3">
          <i class="fa fa-arrow-left"></i>
        </a>
        <b>Selecciona la hora para la cita</b>
      </h5>
      <div class="mb-3">
        <div class="mb-3">{{ eventData.title }} | {{ dateFriend(dateSelect.date) }}</div>
        <div class="text-center">
          <div class="form-row">
            <div
              v-for="(hour, idx) in dateSelect.hours"
              :key="idx"
              class="mb-2"
              :class="twoSchedules ? 'col-6' : 'col-4 col-sm-3'"
            >
              <button
                class="btn btn-sm btn-block"
                :class="`${
                  dateHourSelect && dateHourSelect.date_hour_id === hour.date_hour_id
                    ? 'btn-primary'
                    : 'btn-light'
                }`"
                style="position: relative"
                :disabled="hour.quantityMax <= hour.quantitySold"
                @click="selectDateHour(hour)"
              >
                <span v-if="twoSchedules">
                  {{ getSchedule(hour) }}
                </span>
                <span v-else>
                  {{ parseHourString(hour.timeStart) }}
                </span>
                <div class="btn-dots">
                  <span
                    v-for="(i, idx) in hour.ih"
                    :key="idx"
                    :style="{ background: i.parent.color }"
                    v-b-tooltip.hover
                    :title="i.parent.name"
                  ></span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="msgHour" class="alert alert-warning" v-html="msgHour" />
      <div class="text-right">
        <button
          type="button"
          class="btn btn-action px-5"
          :disabled="!dateHourSelect || loading"
          @click="nextHourSelect()"
        >
          Continuar
        </button>
      </div>
    </div>
    <div v-if="isStep(0.3)">
      <h5 class="mb-3">
        <!-- <a href="#" class="mr-2 text-dark" @click.prevent="step = 0.02;">
          <i class="fa fa-arrow-left"></i>
        </a> -->
        <b>Selecciona la cantidad</b>
      </h5>
      <div class="mb-3">
        <ul class="list-unstyled">
          <li v-for="item in typesData" :key="item.ticketTypeId" class="row align-items-center">
            <div class="col">
              <h5>
                <strong>{{ item.name }}</strong>
              </h5>
              <div>
                <b>S/ {{ item.price }}</b>
              </div>
            </div>
            <div class="col-auto">
              <Counter
                v-model="item.quantity"
                :min="item.minQuantityPerOrder"
                :max="item.maxQuantityPerOrder"
              />
            </div>
          </li>
        </ul>
        <div v-if="error" class="mb-3 text-danger text-center">
          {{ error }}
        </div>
        <div class="text-center">
          <button
            type="button"
            class="btn btn-danger"
            :disabled="loading || !typesSelect.length"
            @click="okTypesDelivery()"
          >
            <i v-if="loading" class="fa fa-spin fa-spinner mr-2"></i>
            Continuar
          </button>
        </div>
      </div>
    </div>
    <form @submit.prevent="validateDataUser()" v-if="isStep(1)">
      <h5 class="mb-3">
        <a href="#" class="mr-2 text-dark" @click.prevent="step = 0.2">
          <i class="fa fa-arrow-left"></i>
        </a>
        <b>Ingresa los datos del comprador</b>
      </h5>
      <div class="form-row">
        <div class="col-12">
          <div class="form-group">
            <label for="name" class="mb-1">Nombres</label>
            <input
              v-model="user.name"
              id="name"
              class="form-control"
              type="text"
              placeholder="nombres completos"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="lastname" class="mb-1">Apellidos</label>
            <input
              v-model="user.lastName"
              id="lastname"
              type="text"
              class="form-control"
              placeholder="apellidos completos"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="email" class="mb-1">Correo</label>
            <input
              v-model="user.email"
              id="email"
              type="email"
              class="form-control"
              placeholder="Correo electrónico"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label for="phone" class="mb-1">Teléfono</label>
            <input
              v-model="user.phone"
              id="phone"
              type="number"
              class="form-control"
              placeholder="Teléfono"
              required
              maxlength="15"
            />
          </div>
        </div>
        <div class="col-5">
          <div class="form-group">
            <label for="doctype" class="mb-1">Tipo documento</label>
            <select v-model="user.documentType" id="doctype" class="form-control">
              <option v-for="i in docTypes" :key="i" :value="i">
                {{ i }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-7">
          <div class="form-group">
            <label for="docNumber" class="mb-1">N° Documento</label>
            <input
              v-model="user.document"
              id="docNumber"
              class="form-control"
              type="tel"
              placeholder="DNI"
              required
              :minlength="user.documentType === 'DNI' ? 8 : 6"
              :maxlength="user.documentType === 'DNI' ? 8 : 15"
              pattern="[a-zA-Z0-9]+"
            />
          </div>
        </div>
        <div v-if="error" class="col-12 mb-3">
          <div class="is-small has-text-danger">
            {{ error }}
          </div>
        </div>
        <div class="col-12">
          <div class="text-right">
            <button type="submit" class="btn btn-action px-5" :disabled="loading">
              <i v-if="loading" class="fa fa-spin fa-spinner mr-2"></i>
              Continuar
            </button>
          </div>
        </div>
      </div>
    </form>
    <form @submit.prevent="step = 3" v-if="isStep(2)">
      <h5 class="mb-3">
        <a href="#" class="mr-2 text-dark" @click.prevent="step = 1">
          <i class="fa fa-arrow-left"></i>
        </a>
        <b>Información de los pacientes</b>
      </h5>
      <!-- pacientes -->
      <div v-for="(t, idxP) in tickets" :key="idxP" class="card mb-3">
        <div class="card-header">
          {{ t.ticketName }}
        </div>
        <div class="card-body pb-0">
          <div v-for="(item, idx) in t.participants" :key="idx" class="row mb-3">
            <div class="col-12">
              <div class="row align-items-center">
                <div class="col">
                  <h5 class="mb-2">
                    <b>Paciente #{{ idx + 1 }}</b>
                  </h5>
                </div>
                <div v-if="idx === 0" class="col-auto">
                  <button
                    @click="autoCompleteItem(item)"
                    type="button"
                    class="btn btn-outline-primary btn-sm mb-2"
                  >
                    Usar datos del comprador
                  </button>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label :for="`pDoct-${idxP}-${idx}`" class="mb-1">Tipo de documento</label>
                <div>
                  <select
                    v-model="item.documentType"
                    :id="`pDoct-${idxP}-${idx}`"
                    class="form-control form-control-sm"
                  >
                    <option v-for="i in docTypes" :key="i" :value="i">
                      {{ i }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label :for="`pDni-${idxP}-${idx}`" class="mb-1">Nro. de documento</label>
                <div>
                  <input
                    v-model="item.document"
                    :id="`pDni-${idxP}-${idx}`"
                    class="form-control form-control-sm"
                    type="tel"
                    placeholder="DNI"
                    required
                    minlength="6"
                    maxlength="15"
                    pattern="[a-zA-Z0-9]+"
                  />
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label :for="`pNames-${idxP}-${idx}`" class="mb-1">Nombres</label>
                <div>
                  <input
                    v-model="item.name"
                    :id="`pNames-${idxP}-${idx}`"
                    class="form-control form-control-sm"
                    type="text"
                    placeholder=""
                    required
                    @input="forceUpper($event, item, 'name')"
                  />
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-group">
                <label :for="`pApepat-${idxP}-${idx}`" class="mb-1">Apellidos</label>
                <div>
                  <input
                    v-model="item.lastName"
                    :id="`pApepat-${idxP}-${idx}`"
                    class="form-control form-control-sm"
                    type="text"
                    placeholder=""
                    required
                    @input="forceUpper($event, item, 'lastName')"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="col-6">
              <div class="form-group">
                <label :for="`pApemat-${idxP}-${idx}`" class="mb-1">Apellido materno</label>
                <div>
                  <input
                    v-model="item.ape_mat"
                    :id="`pApemat-${idxP}-${idx}`"
                    class="form-control form-control-sm"
                    type="text"
                    placeholder=""
                    @input="forceUpper($event, item, 'ape_mat')"
                  >
                </div>
              </div>
            </div> -->
            <div class="col-6">
              <div class="form-group">
                <label class="mb-1">Fecha de nacimiento</label>
                <v-date-picker
                  v-model="item.temp_fn"
                  :max-date="toDateStart"
                  :masks="{ weekdays: 'WWW' }"
                  @input="changeDate($event, item)"
                >
                  <template v-slot="{ inputValue, inputEvents }">
                    <input
                      class="form-control form-control-sm"
                      :value="inputValue"
                      v-on="inputEvents"
                      placeholder="1990-10-01"
                      required
                    />
                  </template>
                </v-date-picker>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label :for="`pSexo-${idxP}-${idx}`" class="mb-1">Sexo</label>
                <div>
                  <select
                    v-model="item.gender"
                    :id="`pSexo-${idxP}-${idx}`"
                    class="form-control form-control-sm"
                    required
                  >
                    <option value="">Seleccionar</option>
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="text-right">
            <button type="submit" class="btn btn-action px-5" :disabled="loading">
              <i v-if="loading" class="fa fa-spin fa-spinner mr-2"></i>
              Continuar
            </button>
          </div>
        </div>
      </div>
    </form>
    <form @submit.prevent="hasDelivery ? saveAddress() : (step = 4)" v-if="isStep(3)">
      <h5 class="mb-3">
        <a href="#" class="mr-2 text-dark" @click.prevent="step = 2">
          <i class="fa fa-arrow-left"></i>
        </a>
        <b>Ingresa los datos de facturación</b>
      </h5>
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label class="mb-1">Tipo de comprobante</label>
            <div>
              <select
                v-model="invoice.tipo_comprobante"
                class="form-control form-control-sm"
                required
              >
                <option value="">Seleccionar</option>
                <option :value="1">Factura</option>
                <option :value="3">Boleta</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="mb-1">Tipo de persona</label>
            <div>
              <select v-model="invoice.tipo_persona" class="form-control form-control-sm" required>
                <option value="">Seleccionar</option>
                <option v-if="invoice.tipo_comprobante !== 1" :value="115">Persona natural</option>
                <option v-if="invoice.tipo_comprobante === 1" :value="116">Persona jurídica</option>
                <option v-if="invoice.tipo_comprobante !== 1" :value="117">
                  Sujeto no domiciliado
                </option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="invoice.tipo_comprobante === 3" class="col-12">
          <div class="form-group">
            <b-form-checkbox v-model="autoCompleteF"> Usar datos del comprador </b-form-checkbox>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label class="mb-1">Tipo documento</label>
            <div>
              <select
                v-model="invoice.tipo_documento"
                class="form-control form-control-sm"
                required
              >
                <option value="">Seleccionar</option>
                <option v-if="invoice.tipo_persona !== 116" :value="1">DNI</option>
                <option v-if="invoice.tipo_persona === 116" :value="6">RUC</option>
                <option v-if="invoice.tipo_persona !== 116" :value="4">Carnet extranjería</option>
                <option v-if="invoice.tipo_persona !== 116" :value="7">Pasaporte</option>
                <option v-if="invoice.tipo_persona !== 116" :value="5">Otros</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="invoice.tipo_persona !== 116 && invoice.tipo_comprobante !== 1" class="col-6">
          <div class="form-group">
            <label class="mb-1">Nro. de documento</label>
            <div>
              <input
                v-model="invoice.id_cliente"
                class="form-control form-control-sm"
                type="tel"
                placeholder=""
                required
                :minlength="invoice.tipo_documento === 1 ? 8 : 6"
                :maxlength="invoice.tipo_documento === 1 ? 8 : 15"
              />
            </div>
          </div>
        </div>
        <div v-if="requireRuc" class="col-6">
          <div class="form-group">
            <label class="mb-1">RUC</label>
            <div>
              <input
                v-model="invoice.ruc"
                class="form-control form-control-sm"
                type="tel"
                placeholder=""
                minlength="11"
                maxlength="11"
                pattern="\d*"
                required
              />
            </div>
          </div>
        </div>
        <div v-if="requireRuc" :class="invoice.tipo_persona === 116 ? 'col-12' : 'col-6'">
          <div class="form-group">
            <label class="mb-1">Razón social | Nombre</label>
            <div>
              <input
                v-model="invoice.nombre_cliente"
                class="form-control form-control-sm"
                type="text"
                placeholder=""
                required
                @input="forceUpper($event, invoice, 'nombre_cliente')"
              />
            </div>
          </div>
        </div>
        <div v-if="invoice.tipo_comprobante === 3" class="col-6">
          <div class="form-group">
            <label class="mb-1">Primer nombre</label>
            <div>
              <input
                v-model="invoice.primer_nombre"
                class="form-control form-control-sm"
                type="text"
                placeholder=""
                required
                @input="forceUpper($event, invoice, 'primer_nombre')"
              />
            </div>
          </div>
        </div>
        <div v-if="invoice.tipo_comprobante === 3" class="col-6">
          <div class="form-group">
            <label class="mb-1">Segundo nombre</label>
            <div>
              <input
                v-model="invoice.segundo_nombre"
                class="form-control form-control-sm"
                type="text"
                placeholder=""
                @input="forceUpper($event, invoice, 'segundo_nombre')"
              />
            </div>
          </div>
        </div>
        <div v-if="invoice.tipo_comprobante === 3" class="col-6">
          <div class="form-group">
            <label class="mb-1">Primer apellido</label>
            <div>
              <input
                v-model="invoice.primer_apellido"
                class="form-control form-control-sm"
                type="text"
                placeholder=""
                required
                @input="forceUpper($event, invoice, 'primer_apellido')"
              />
            </div>
          </div>
        </div>
        <div v-if="invoice.tipo_comprobante === 3" class="col-6">
          <div class="form-group">
            <label class="mb-1">Segundo apellido</label>
            <div>
              <input
                v-model="invoice.segundo_apellido"
                class="form-control form-control-sm"
                type="text"
                placeholder=""
                @input="forceUpper($event, invoice, 'segundo_apellido')"
              />
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="mb-1">Correo electrónico</label>
            <div>
              <input
                v-model="invoice.email"
                class="form-control form-control-sm"
                type="email"
                placeholder="Correo electrónico"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="mb-1">Dirección</label>
            <div>
              <input
                v-model="invoice.direccion"
                class="form-control form-control-sm"
                type="text"
                placeholder=""
                required
                @input="forceUpper($event, invoice, 'direccion')"
              />
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="text-right">
            <button type="submit" class="btn btn-action px-5" :disabled="loading">
              <i v-if="loading" class="fa fa-spin fa-spinner mr-2"></i>
              Continuar
            </button>
          </div>
        </div>
      </div>
    </form>
    <div v-if="isStep(3.1)">
      <DeliveryAddress
        :eventData="eventData"
        :user="user"
        @prev="step = 0.3"
        @submit="okDelivery($event)"
      ></DeliveryAddress>
    </div>
    <div v-if="isStep(4)">
      <h5 class="mb-4">
        <a href="#" class="mr-2 text-dark" @click.prevent="step = 3">
          <i class="fa fa-arrow-left"></i>
        </a>
        <b>Generar reserva</b>
      </h5>
      <div>
        <div v-for="(i, idx) in ticketsEnd" :key="idx" class="mb-2">
          <b>{{ i.quantity }} x {{ i.name }}</b>
          <b> - </b>
          <b class="text-success"> {{ currencySymbol }} {{ i.price }} </b>
        </div>
        <div class="mb-2">
          <b>{{ eventData.title }}</b>
        </div>
        <div class="mb-2">
          <b>{{ dateFriend(dateSelect.date) }}</b>
        </div>
        <div class="mb-2">
          <b>
            {{ twoSchedules ? 'Horario: ' : 'Hora: ' }}
            {{
              twoSchedules ? getSchedule(dateHourSelect) : parseHourString(dateHourSelect.timeStart)
            }}
          </b>
        </div>
        <div v-if="dataDelivery" class="mb-2">
          <h6 class="text-uppercase">
            <b>Delivery</b>
          </h6>
          <div>
            <b>Dirección:</b>
            {{ dataDelivery.ubigeo[0].displayName }}, {{ dataDelivery.address }} -
            {{ dataDelivery.lot }}
          </div>
          <div v-if="dataDelivery.reference"><b>Referencia:</b> {{ dataDelivery.reference }}</div>
          <b>Costo:</b> {{ dataDelivery.deliveryZone.deliveryFee }}
        </div>
        <div class="mb-3">
          <b>Total a pagar: </b>
          <b class="text-success">{{ currencySymbol }} {{ totalPay.toFixed(2) }}</b>
        </div>
        <div class="bg-light rounded p-3 mb-3">
          <h6>
            <b>Datos de comprador</b>
          </h6>
          <div>
            {{ `${user.name} ${user.lastName}` }} <br />
            {{ user.email }} <br />
            {{ user.phone }}
          </div>
        </div>
        <div v-if="files && !isHeadquarters" class="mb-3">
          <b>Importante:</b>
          Las siguientes fichas se adjuntarán; recuerda especificar que es obligatorio llevar las
          fichas firmadas y selladas por un profesional de la salud.
          <br />
          <div v-for="doc in files" :key="doc.name">
            <a :href="doc.fileUrl" download target="_blank">
              {{ doc.name }}
            </a>
          </div>
        </div>
        <div v-if="error" class="text-danger small mb-3">
          {{ error }}
        </div>
        <div v-if="errorDelivery" class="text-danger small mb-3">
          {{ errorDelivery }}
        </div>
        <div class="text-right">
          <button
            v-if="isHeadquarters"
            type="button"
            class="btn btn-primary px-5"
            @click="step = 6"
          >
            Confirmar y continuar
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary px-5"
            :disabled="loading"
            @click="buyTickets()"
          >
            <i v-if="loading" class="fa fa-spin fa-spinner mr-2"></i>
            Confirmar reserva
          </button>
        </div>
      </div>
    </div>
    <div v-if="isStep(5)" class="text-center py-3">
      <h5 class="mb-2">
        <b>Reserva generada correctamente</b>
      </h5>
      <h6 class="mb-4">
        <b>Estará disponible para pagar por 15 minutos</b>
      </h6>
      <div class="mb-4">
        <a :href="linkPay" target="_blank" class="btn btn-primary"> Ver link de pago </a>
      </div>
      <div v-if="loadingLink">
        <i class="fa fa-spin fa-spinner fa-2x"></i>
        <br />
        Enviando link de pago
      </div>
      <div v-else class="mb-4">
        <div v-if="error">Error al enviar el link de pago.</div>
        <div v-else>
          Se ha enviado un correo con el link de pago a: <br />
          <span class="text-primary">
            {{ user.email || 'Error' }}
          </span>
        </div>
      </div>
      <hr />
      <div class="px-2">
        <h6 class="mb-3 text-uppercase">
          <b>Compartir</b>
        </h6>
        <div class="row">
          <div class="col-6">
            <a :href="shareWp" target="_blank" class="btn btn-primary btn-sm btn-block">
              Enviar vía Whatsapp
            </a>
          </div>
          <div class="col-6">
            <a
              href="#"
              class="btn btn-outline-primary btn-sm btn-block"
              @click.prevent="modalResend = true"
            >
              Reenviar link de pago
            </a>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isStep(6)">
      <h3 class="mb-4 d-flex align-items-center">
        <button @click="step = 4" class="btn btn-outline-secondary btn-sm mr-4">Atrás</button>
        <span>Formas de pago</span>
      </h3>
      <PayMethods v-model="formPay" :hide-visaqr="true"></PayMethods>
      <div class="text-right my-4">
        <div class="h4"><b>Total a pagar: </b> {{ currencySymbol }} {{ totalPay.toFixed(2) }}</div>
      </div>
      <div class="text-right">
        <button
          class="btn btn-action btn-lg"
          type="button"
          :disabled="formPay.type === 'pos' && !formPay.code"
          @click="modalConfirm = true"
        >
          Generar entradas
        </button>
      </div>
    </div>
    <div v-if="isStep(6.1)" class="text-center py-3">
      <h3 class="text-center">Registro de compra exitoso!!</h3>
      <hr />
      <br />
      <p class="text-center">
        <a
          :href="`/print/${transactionPos.ticketId}`"
          target="_blank"
          class="btn btn-action btn-lg"
        >
          Imprimir
        </a>
      </p>
      <br />
      <p class="text-center">
        <button @click="confirmNew = true" type="button" class="btn btn-primary">
          Nueva venta
        </button>
      </p>
    </div>
    <b-modal
      v-model="modalResend"
      title="Reenviar link de pago"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <form @submit.prevent="sendLink()" class="p-3">
        <div class="form-group">
          <label for="nemail" class="mb-1">Nuevo Correo electrónico</label>
          <input
            v-model="newEmail"
            id="nemail"
            type="email"
            class="form-control"
            placeholder=""
            required
          />
        </div>
        <div class="text-center mt-4">
          <button type="submit" class="btn btn-action px-5" :disabled="loadingLink">
            <i v-if="loadingLink" class="fa fa-spin fa-spinner mr-2"></i>
            Enviar
          </button>
        </div>
      </form>
    </b-modal>
    <!-- modal confirm POS -->
    <b-modal v-model="modalConfirm" hide-header hide-footer>
      <div class="my-5 text-center">
        <h5>
          <b>Total a pagar: {{ currencySymbol }} {{ totalPay.toFixed(2) }}</b>
        </h5>
        <br />
        <h4>
          ¿Estás seguro que deseas realizar la transacción con Método de pago: <br />
          <b class="text-uppercase">
            {{ formPay.type }}
            <span v-if="formPay.card"> - {{ formPay.card }}</span> </b
          >?
        </h4>
        <br />
        <p v-if="loading">
          <b-spinner small></b-spinner>
        </p>
        <p v-if="error" class="text-action">
          <b>Algo salió mal: </b>
          <span>{{ error }}</span>
        </p>
        <div style="max-width: 420px; margin: auto">
          <div class="row">
            <div class="col-6">
              <button
                @click="modalConfirm = false"
                type="button"
                class="btn btn-secondary btn-lg btn-block"
              >
                Cerrar
              </button>
            </div>
            <div class="col-6">
              <button
                @click="onPaymentSend()"
                :disabled="loading"
                type="button"
                class="btn btn-action btn-lg btn-block"
              >
                Procesar
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      v-model="confirmNew"
      hide-header
      cancel-title="Cerrar"
      ok-title="Confirmar"
      ok-variant="action ml-3"
      @ok="$emit('ok')"
    >
      <div class="text-center">
        <p class="lead p-4">¿Estás segur@ que deseas salir de la pantalla de impresión?</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios';
import jwt from 'jsonwebtoken';
import Multiselect from 'vue-multiselect';

import api from '../api';

const colors = ['red', 'green', 'blue'];

const docTypes = ['DNI', 'RUC', 'PASS', 'CE', 'OTRO'];

const paciente = {
  fecha_programacion: '',
  dni: '',
  nombres: '',
  ape_pat: '',
  ape_mat: '',
  fecha_nac: '',
  sexo: '',
  origen_externo: 'AUTOCV_001',
  telefono: '',
  email: '',
  password: null,
  address: '',
  reference: '',
  distrito: ''
};

const participant = {
  name: '', // ok
  lastName: '', // ok
  documentType: 'DNI', // ok
  document: '', // ok
  birthdate: '', // ok
  gender: '', // ok
  email: '', // ok-n
  phone: '', // ok-n
  address: '', // ok-n
  district: '', // ok-n
  reference: '', // ok-n
  externalOrigin: 'AUTOCV_001'
};

export default {
  components: {
    Multiselect
  },
  props: {
    eventData: Object
  },
  data() {
    return {
      docTypes,
      step: 0,
      loading: false,
      loadingLink: false,
      modalResend: false,
      error: '',
      products: [],
      product: null,
      pAddress: {
        address: '',
        reference: ''
      },
      datesData: [],
      typesData: [],
      dateSelect: null,
      dateHourSelect: null,
      // typeSelect: null,
      ticketsEnd: [],
      msgHour: '',
      // calendar
      selectedDate: null,
      fechaNac: null,
      // data
      user: {
        name: '',
        lastName: '',
        email: '',
        documentType: 'DNI',
        document: '',
        reemail: '',
        phone: ''
        // terms: false,
        // download: false,
      },
      paciente,
      tickets: [],
      otrosPacientes: [],
      invoice: {
        origen_externo: 'AUTOCV_001',
        tipo_comprobante: '',
        tipo_persona: '',
        tipo_documento: '',
        id_cliente: '',
        ruc: '',
        nombre_cliente: '',
        primer_nombre: '',
        segundo_nombre: '',
        primer_apellido: '',
        segundo_apellido: '',
        email: '',
        direccion: '',
        total_con_igv: null,
        cantidad_detalle: null,
        nombre_completo_paciente: ''
      },
      autoCompleteP: false,
      autoCompleteF: false,
      linkPay: '',
      newEmail: '',
      // delivery
      formAddress: {},
      transaction: null,
      dataDelivery: null,
      errorDelivery: '',
      isHeadquarters: false,
      formPay: {
        type: 'efectivo',
        card: null,
        code: null
      },
      transactionPos: {},
      modalConfirm: false,
      confirmNew: false
    };
  },
  mounted() {
    // this.getDataMerch();
    // this.getDataEvent();
    if (!this.hasDelivery) {
      this.step = 0.001;
    } else {
      this.getAllTickets();
    }
  },
  computed: {
    toDateStart() {
      const d = new Date();
      const day = 1000 * 60 * 60 * 24;
      d.setTime(d.getTime() - day * 2);
      return d;
    },
    requireRuc() {
      return this.invoice.tipo_comprobante === 1 && this.invoice.tipo_persona === 116;
    },
    pacienteAllName() {
      // eslint-disable-next-line
      const { name, lastName } = this.tickets[0].participants[0];
      // eslint-disable-next-line
      return `${name} ${lastName}`;
    },
    typesSelect() {
      return this.typesData.filter((i) => i.quantity);
    },
    availableDates() {
      let dates = [];
      const dt = new Date();
      const [now] = dt.toJSON().split('T');
      this.datesData.forEach((i) => {
        const dts = i[0].dates.map((d) => d.date);
        dates = [...dates, ...dts];
      });
      if (this.isHeadquarters) {
        dates = dates.filter((i) => i === now);
      }
      return dates.map((item) => ({
        start: new Date(`${item} 00:00:00`),
        end: new Date(`${item} 23:59:59`)
      }));
    },
    attributes() {
      const attrs = [];
      this.datesData.forEach((i, idx) => {
        const dates = i[0].dates.map((d) => d.date);
        const item = {
          key: i[0].ticketTypeId,
          dot: { color: colors[idx] },
          popover: { label: i[0].name },
          dates
        };
        attrs.push(item);
      });
      return attrs;
    },
    shareWp() {
      const wp = 'https://api.whatsapp.com/send';
      return `${wp}?phone=${this.user.phone}&text=Link de pago @joinnus: ${this.linkPay}`;
    },
    totalPay() {
      if (!this.tickets.length) return 0;
      const tt = this.tickets.map((i) => i.price * i.quantity).reduce((a, b) => a + b);
      return this.dataDelivery ? tt + parseFloat(this.dataDelivery.deliveryZone.deliveryFee) : tt;
    },
    hasDelivery() {
      const del = this.getMetaValue(this.eventData.metadata, 'delivery');
      return !!del;
    },
    files() {
      const files = this.getMetaValue(this.eventData.metadata, 'unilabs_document');
      return files ? JSON.parse(files) : '';
    },
    twoSchedules() {
      const fd = this.getMetaValue(this.eventData.metadata, 'twoSchedules');
      return !!fd;
    },
    currencySymbol() {
      return this.eventData.currency === 'PEN' ? 'S/' : '$';
    }
  },
  watch: {
    autoCompleteP(val) {
      if (val) {
        this.autoCompletePaciente();
      } else {
        this.autoCompletePaciente('clear');
      }
    },
    autoCompleteF(val) {
      if (val) {
        this.autoCompleteInvoice();
      } else {
        this.autoCompleteInvoice('clear');
      }
    }
  },
  methods: {
    getSchedule({ timeStart, timeEnd }) {
      const str = parseInt(timeEnd.substr(0, 2), 10) <= 13 ? 'Mañana' : 'Tarde';
      return `${str}: ${this.parseHourString(timeStart)} - ${this.parseHourString(timeEnd)}`;
    },
    labelDistrict(item) {
      return `${item.name} - S/ ${item.price.toFixed(2)}`;
    },
    isStep(step) {
      return this.step === step;
    },
    forceUpper(e, o, prop) {
      const start = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      this.$set(o, prop, e.target.value);
      e.target.setSelectionRange(start, start);
    },
    isSoldOut(type) {
      const sold = type.quantitySold + type.quantitySoldPendingPayment;
      const res = (sold >= type.quantityMax && type.quantityMax > 0) || type.soldOut;
      return !!res;
    },
    getMaxQuantity(ticket) {
      const { quantityMax, quantitySold, quantitySoldPendingPayment, maxQuantityPerOrder } = ticket;
      let available = quantityMax - (quantitySold + quantitySoldPendingPayment);
      if (available > maxQuantityPerOrder) {
        available = maxQuantityPerOrder;
      }
      return available;
    },
    okTypeShop(isHeadquarters) {
      this.isHeadquarters = isHeadquarters;
      this.getAllTickets();
    },
    selectDate(day) {
      if (!day) {
        this.dateSelect = null;
        return;
      }
      const [id] = this.selectedDate.toISOString().split('T');
      this.paciente.fecha_programacion = id.replace(/-/g, '');
      // this.dateSelect = this.datesData[id];
    },
    nextSelectDate() {
      const [id] = this.selectedDate.toISOString().split('T');
      this.datesData.forEach((item) => {
        const fd = item[0].dates.find((i) => i.date === id);
        if (fd && fd.hours.length) {
          this.dateSelect = fd;
        }
      });
      this.dateSelect.hours.map((hour) => {
        this.verifyHourItems(hour);
        return hour;
      });
      this.step = 0.2;
      this.msgHour = '';
    },
    verifyHourItems(hour) {
      const [id] = this.selectedDate.toISOString().split('T');
      const fd = [];
      this.datesData.forEach((item, idx) => {
        const f = item[0].dates.find((i) => i.date === id);
        if (f) {
          this.$set(f, 'color', colors[idx]);
          this.$set(f, 'name', item[0].name);
          this.$set(f, 'ticketTypeId', item[0].ticketTypeId);
          fd.push(f);
        }
      });
      const ih = [];
      fd.forEach((item) => {
        const f = item.hours.find((i) => i.date_hour_id === hour.date_hour_id);
        if (f) {
          const obj = { ...f, parent: item };
          ih.push(obj);
        }
      });
      this.$set(hour, 'ih', ih);
    },
    selectDateHour(hour) {
      this.dateHourSelect = hour;
      this.msgHour = '';
      const tps = [];
      hour.ih.forEach((item) => {
        const fd = this.typesSelect.find((i) => i.ticketTypeId === item.parent.ticketTypeId);
        if (fd) {
          tps.push({ ...fd, hour: item });
        }
      });
      const check = this.typesSelect.length === this.dateHourSelect.ih.length;
      if (!check) {
        const tpsNames = tps.map((i) => i.parent.name).join();
        this.msgHour = `Recuerda la reserva se hará para los tipos: <b>${tpsNames}</b>`;
      }
      this.ticketsEnd = tps;
      // generate tickets
      this.tickets = [];
      tps.forEach((item) => {
        const nItem = {
          event_id: this.eventData.activityId,
          activity_date_hour_id: hour.date_hour_id,
          ticket_type_id: item.ticketTypeId,
          price: item.price,
          ticketName: item.name,
          quantity: item.quantity,
          coupon: '',
          start_date: '',
          seats: [],
          billing: false,
          participant: false,
          participants: []
        };
        for (let i = 0; i < item.quantity; i++) {
          // eslint-disable-line
          const pj = JSON.parse(JSON.stringify(participant));
          nItem.participants.push(pj);
        }
        this.tickets.push(nItem);
      });
    },
    nextHourSelect() {
      this.step = 1;
    },
    changeDate(day, vm) {
      const [id] = day.toISOString().split('T');
      vm.birthdate = id.replace(/-/g, '');
    },
    okType(item) {
      // no
      this.typeSelect = item;
      this.step = 1;
      if (item.quantity > 1) {
        for (let i = 0; i < item.quantity - 1; i++) {
          // eslint-disable-line
          const p = JSON.parse(JSON.stringify(paciente));
          this.otrosPacientes.push(p);
        }
      }
    },
    okTypesDelivery() {
      if (this.hasDelivery) {
        this.step = 3.1;
      } else {
        this.okTypes();
      }
    },
    async okTypes() {
      const payload = [];
      this.error = '';
      this.typesSelect.forEach(({ ticketTypeId: ticketType, quantity }) => {
        const tk = { ticketType, quantity };
        payload.push(tk);
      });
      this.loading = true;
      const data = {
        payload,
        allHours: this.isHeadquarters
      };
      const res = await api.getVerifyTickets(this.eventData.activityId, data);
      this.loading = false;
      if (res.status) {
        this.datesData = res.data;
        if (!this.availableDates.length) {
          this.error = 'No se encontró fechas disponibles para Venta en Sede';
        } else {
          this.step = 0.1;
        }
      }
    },
    userBuyedOk() {
      this.step = 2;
    },
    async getDataMerch() {
      this.loading = true;
      const slug = this.getMetaValue(this.eventData.metadata, 'storeSlug');
      if (!slug) {
        this.$bvToast.toast('Error: configure "storeSlug" en el evento', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
        return;
      }
      const query = `
        query merchdata{
          merchandises (organizer: "${slug}", limit: 60) {
            data{
              id
              name
              price
              sku
            }
          }
        }
      `;
      try {
        const { data } = await api.graphqlAxios.post('', { query });
        this.products = data.data.merchandises.data;
        this.step = 0.01;
      } catch (e) {
        this.$bvToast.toast('Error de merchandise', {
          title: 'Error',
          variant: 'danger',
          solid: true
        });
      }
      this.loading = false;
    },
    async getAllTickets() {
      this.loading = true;
      const res = await api.getAllTickets(this.eventData.activityId);
      this.loading = false;
      if (res.status) {
        this.typesData = res.data.tickets.map((el) => {
          this.$set(el, 'quantity', 0);
          return el;
        });
        this.step = 0.3;
      }
    },
    async getDataEvent() {
      this.loading = true;
      const dates = await api.getEventDates(this.eventData.activityId);
      const now = new Date();
      const dt = new Date();
      const yesterday = new Date(dt.setDate(dt.getDate() - 1));
      const [idNow] = now.toISOString().split('T');
      const [idYesterday] = yesterday.toISOString().split('T');
      delete dates[idNow];
      delete dates[idYesterday];
      this.datesData = dates;

      this.loading = false;
      this.step = 0.1;
    },
    async getDataTypes() {
      this.loading = true;
      const types = await api.getEventTypes(this.eventData.activityId, this.dateHourSelect.timeId);
      const typesDataFilter = types.filter((i) => !i.isFov);
      this.typesData = typesDataFilter.map((el) => {
        this.$set(el, 'quantity', 1);
        return el;
      });
      this.loading = false;
      this.step = 0.3;
    },
    async validateDataUser() {
      let validate = true;
      this.error = '';
      if (this.user.documentType === 'DNI') {
        validate = await this.validateUser({
          ...this.user,
          fullName: `${this.user.name} ${this.user.lastName}`
        });
      }

      if (!validate) return;
      this.step = 2;
    },
    async buyTickets() {
      this.error = '';
      const qAll = this.tickets.map((i) => i.quantity).reduce((a, b) => a + b);
      this.invoice.nombre_completo_paciente = this.pacienteAllName;
      this.invoice.cantidad_detalle = qAll;
      this.invoice.movilidad = this.hasDelivery && this.dataDelivery.deliveryZone.deliveryFee;
      // ok
      const user = {
        ...this.user,
        user_id: '',
        session: '',
        iso: 'PE',
        origin: 'boxoffice-callcenter-lab',
        token: 'abc',
        unique: '-'
      };

      const p1 = this.tickets[0].participants[0];

      // fallback
      const [ap, am] = p1.lastName.split(' ');
      this.paciente.dni = p1.document;
      this.paciente.nombres = p1.name;
      this.paciente.ape_pat = ap;
      this.paciente.ape_mat = am;
      this.paciente.fecha_nac = p1.birthdate;
      this.paciente.sexo = p1.gender;
      // from user
      this.paciente.telefono = this.user.phone;
      this.paciente.email = this.user.email;
      this.paciente.address = this.hasDelivery && this.dataDelivery.address;
      this.paciente.reference = this.hasDelivery && this.dataDelivery.reference;
      this.paciente.distrito = this.hasDelivery && this.dataDelivery.ubigeo[0].isoCode;

      const allP = [];
      this.tickets.map((i) => {
        i.participants.map((p) => {
          this.$set(p, 'phone', this.user.phone);
          this.$set(p, 'email', this.user.email);
          this.$set(p, 'address', this.hasDelivery && this.dataDelivery.address);
          this.$set(p, 'reference', this.hasDelivery && this.dataDelivery.reference);
          this.$set(p, 'distrito', this.hasDelivery && this.dataDelivery.ubigeo[0].isoCode);
          return p;
        });
        return i;
      });
      const allParticipants = this.tickets.map((i) => i.participants).reduce((a, b) => a.concat(b));
      allParticipants.forEach((item) => {
        const p = { ...paciente };
        const [iap, iam] = item.lastName.split(' ');
        p.dni = item.document;
        p.nombres = item.name;
        p.ape_pat = iap;
        p.ape_mat = iam;
        p.fecha_nac = item.birthdate;
        p.sexo = item.gender;
        allP.push(p);
      });

      allP.splice(0, 1);

      const payload = {
        user,
        type: {
          product: [],
          donacion: [],
          event: this.tickets
        },
        fovCode: '',
        timeExpiration: null,
        unilabs: {
          paciente: this.paciente,
          invoice: this.invoice,
          otrosPacientes: allP
        }
      };

      this.loading = true;

      const details = jwt.sign(payload, 'jnputin', { noTimestamp: true });
      const search = window.location.search.replace(/\?/g, '&');
      const res = await api.reservation(details, true, 'joinnus-callcenter-lab', search);

      this.loading = false;

      if (res.status) {
        this.linkPay = res.route;
        this.transaction = res.data;
        if (this.hasDelivery) {
          this.saveAddressTransaction();
        } else {
          this.step = 5;
          this.sendLink();
        }
      } else {
        this.error = res.message;
        setTimeout(() => {
          this.error = '';
        }, 9000);
      }
    },
    async sendLink() {
      this.loadingLink = true;
      const sHour = this.parseHourString(this.dateHourSelect.timeStart);
      const eHour = this.parseHourString(this.dateHourSelect.timeEnd);
      const pHour = this.hasDelivery ? `${sHour} - ${eHour}` : sHour;
      const dateFriend = this.dateFriend(this.dateSelect.date);
      const payload = {
        type: 'PAYMENT_LINK',
        data: {
          link: this.linkPay,
          email: this.newEmail || this.user.email,
          name: `${this.user.name} ${this.user.lastName}`,
          title: this.eventData.title,
          date: `${dateFriend} | ${pHour}`,
          bannerUrl: this.eventData.image,
          files: this.files
        }
      };
      try {
        const res = await api.sendLinkEmail(payload);
        if (!res.success) {
          this.error = '1';
        }
      } catch (err) {
        this.error = '1';
      }
      this.loadingLink = false;
    },
    async onPaymentSend() {
      this.error = '';
      this.loading = true;
      const sessionId = this.$store.state.auth.token;
      const { type, code: codepos } = this.formPay;
      const user = {
        ...this.user,
        sexo: 'm',
        sessionId, // vendedor
        deviceSessionID: null, // vendedor
        origin: 'boxoffice-pos-lab',
        source: 'web',
        iso: 'PE',
        // extra
        date_birthday: '',
        provincia: ''
      };
      // fix
      user.lastname = this.user.lastName;
      const coupon = {
        code: null
      };
      const payment = {
        ip: null,
        specialPrice: false,
        method_payment: type,
        currency: this.eventData.currency,
        paymentTotal: this.totalPay, // specialPrice custom
        reason: ''
      };

      const event = {
        id: this.eventData.activityId,
        activity_date_hour_id: this.dateHourSelect.date_hour_id,
        types: []
      };
      event.types = this.tickets.map((tk) => {
        tk.participants.map((p) => {
          this.$set(p, 'phone', this.user.phone);
          this.$set(p, 'email', this.user.email);
          return p;
        });
        const nt = {
          ticketTypeId: tk.ticket_type_id,
          quantity: tk.quantity,
          seats: null,
          participants: tk.participants
        };
        return nt;
      });

      const payload = {
        participants: [],
        sellingPointId: null,
        user,
        payment,
        events: [event],
        coupon,
        invoice: this.invoice
      };

      if (codepos) {
        payload.codepos = codepos;
      }
      const token = jwt.sign(payload, 'jnputin', { noTimestamp: true });
      const url = `${api.checkoutUrl}/payment/process/point-of-sale`;
      const { data: res } = await api.axios.post(url, { data: token });
      this.loading = false;
      if (!res.success) {
        this.error = res.messagePayment;
        return;
      }
      this.transactionPos = res.data;
      this.modalConfirm = false;
      this.step = 6.1;
    },
    async validateUser(user) {
      this.loading = true;
      try {
        const url = `${process.env.VUE_APP_API_PLATFORM}/endpoints/validate-documents`;
        const { data: res } = await axios.post(url, [user]);
        this.loading = false;
        if (!res.data[0].status) {
          this.error = res.data[0].message;
          return false;
        }
        return true;
      } catch (err) {
        this.error = 'Inténtalo en un momento.';
        this.loading = false;
        setTimeout(() => {
          this.error = '';
        }, 9000);
        return false;
      }
    },
    autoCompleteItem(item) {
      if (item.auto) {
        item = { ...JSON.parse(JSON.stringify(participant)) };
        this.$set(item, 'auto', false);
      } else {
        const user = { ...this.user };
        item.name = user.name;
        item.lastName = user.lastName;
        item.documentType = user.documentType;
        item.document = user.document;
        // item.email = user.email;
        // item.phone = user.phone;
        this.$set(item, 'auto', true);
      }
    },
    autoCompletePaciente(clear) {
      if (clear === 'clear') {
        this.paciente.dni = '';
        this.paciente.email = '';
        this.paciente.nombres = '';
        this.paciente.ape_pat = '';
        this.paciente.ape_mat = '';
        this.paciente.telefono = '';
      } else {
        const user = { ...this.user };
        const [a1, a2] = user.lastName.split(' ');
        this.paciente.dni = user.documentType === 'DNI' ? user.document : '';
        this.paciente.email = user.email;
        this.paciente.telefono = user.phone;
        this.paciente.nombres = user.name.toUpperCase();
        this.paciente.ape_pat = a1.toUpperCase();
        this.paciente.ape_mat = a2.toUpperCase();
      }
    },
    autoCompleteInvoice(clear) {
      if (clear === 'clear') {
        this.invoice.tipo_documento = '';
        this.invoice.id_cliente = '';
        this.invoice.email = '';
        this.invoice.telefono = '';
        this.invoice.primer_nombre = '';
        this.invoice.segundo_nombre = '';
        this.invoice.primer_apellido = '';
        this.invoice.segundo_apellido = '';
      } else {
        const user = { ...this.user };
        const [n1, n2] = user.name.split(' ');
        const [a1, a2] = user.lastName.split(' ');

        this.invoice.tipo_documento = user.documentType === 'DNI' ? 1 : '';
        this.invoice.id_cliente = user.document;
        this.invoice.email = user.email;
        this.invoice.telefono = user.phone;
        this.invoice.primer_nombre = n1.toUpperCase();
        this.invoice.segundo_nombre = n2.toUpperCase();
        this.invoice.primer_apellido = a1.toUpperCase();
        this.invoice.segundo_apellido = a2.toUpperCase();
      }
    },
    okDelivery(data) {
      this.formAddress = data;
      this.okTypes();
    },
    async saveAddress() {
      const { name: firstName, lastName, documentType, document, phone } = this.user;
      const payload = {
        ...this.formAddress,
        firstName,
        lastName,
        documentType,
        document,
        phone
      };
      this.loading = true;
      const { data } = await api.axios.post('/addresses', payload);
      this.loading = false;
      if (data.status) {
        this.dataDelivery = {
          ...data.data,
          deliveryZone: this.formAddress.deliveryZone
        };
        this.step = 4;
      }
    },
    setErrorDelivery(msg) {
      this.errorDelivery = msg;
      setTimeout(() => {
        this.errorDelivery = '';
      }, 9000);
    },
    async saveAddressTransaction() {
      this.loading = true;
      const payload = {
        ticketId: this.transaction.data,
        addressId: this.dataDelivery.id
      };
      try {
        const url = `${api.checkoutUrl}/reservation/add-delivery`;
        const { data } = await api.axios.post(url, payload);
        const codeOk = ['delivery-added', 'error-transaction-delivery-added'];
        if (codeOk.includes(data.code)) {
          this.step = 5;
          this.sendLink();
        } else {
          this.setErrorDelivery(data.message);
        }
      } catch (err) {
        const codeOk = ['error-transaction-delivery-added'];
        if (err.response.data && codeOk.includes(err.response.data.code)) {
          this.step = 5;
          this.sendLink();
        } else {
          this.setErrorDelivery('Error al asignar el delivery');
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
.btn-dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -5px;
  text-align: center;
  span {
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #000;
    margin: 1px;
  }
}
</style>
